<script setup lang="ts">
import { Container } from '@/components/Container';
import { Skeleton } from '@/components/ui/skeleton';
</script>

<template>
	<section class="relative h-[727px] w-full bg-white-dark-1 sm:h-[744px]">
		<Skeleton
			variant="white"
			class="mb-12 h-[34px] w-[359px]"
			is-active
		></Skeleton>
		<Skeleton
			variant="white"
			class="flex h-[440px] w-full !flex-col justify-between p-6"
			is-active
			only-skeleton
		>
			<div class="flex flex-row gap-6">
				<Skeleton
					v-for="i in 6"
					:key="i"
					variant="whiteHighlight"
					class="mb-12 h-[34px] w-[86px]"
					is-active
				></Skeleton>
			</div>
			<div class="flex flex-col justify-between gap-6 xl:flex-row">
				<div class="flex flex-col justify-end gap-4">
					<Skeleton
						variant="whiteHighlight"
						class="h-[28px] w-[141px]"
						is-active
					></Skeleton>
					<Skeleton
						variant="whiteHighlight"
						class="h-[14px] w-[470px]"
						is-active
					></Skeleton>
					<Skeleton
						variant="whiteHighlight"
						class="h-[14px] w-[170px]"
						is-active
					></Skeleton>
				</div>
				<div
					class="flex min-w-[650px] flex-row flex-wrap gap-2 lg:min-w-[unset] xl:max-w-[310px] 2xl:max-w-[650px]"
				>
					<Skeleton
						v-for="i in 4"
						:key="i"
						variant="whiteHighlight"
						class="size-[150px]"
						is-active
					></Skeleton>
				</div>
			</div>
		</Skeleton>
		<div class="mt-9 flex w-full flex-row justify-between">
			<Skeleton variant="white" class="h-[52px] w-[267px]" is-active></Skeleton>
		</div>
	</section>
</template>
